import { render, staticRenderFns } from "./ComisionesFondeador.vue?vue&type=template&id=324de15a"
import script from "./ComisionesFondeador.vue?vue&type=script&lang=js"
export * from "./ComisionesFondeador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports